$(document).ready(function () {

  function initMobileSlider() {
    var $slider = $(".mobile-slider .kk-collection-row");

    if ($(window).width() < 767) {
      if (!$slider.hasClass("flickity-enabled")) {
        $slider.flickity({
          cellAlign: "left",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          wrapAround: true,
        });
      }
    } else {
      if ($slider.hasClass("flickity-enabled")) {
        $slider.flickity("destroy");
      }
    }
  }

  initMobileSlider();

  // Run on load + resize
  $(window).on("resize", initMobileSlider);

  // Black Friday Deals Mobile Slider
  function initBlackFridayMobileSlider() {
    var $slider = $(".black-friday-deals-body .logo-list");
    var windowWidth = $(window).width();

    if (windowWidth <= 768) {
      // Remove is-hidden class before initializing Flickity
      $slider.removeClass("is-hidden");

      // Destroy existing instance to reinitialize with new settings
      if ($slider.hasClass("flickity-enabled")) {
        $slider.flickity("destroy");
      }

      // Determine grouping based on window width
      var groupCells = windowWidth <= 575 ? 1 : 2;

      $slider.flickity({
        cellAlign: "left",
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 3000,
       pauseAutoPlayOnHover: true,
      });
    } else {
      if ($slider.hasClass("flickity-enabled")) {
        $slider.flickity("destroy");
      }
      // Show slides in grid mode on desktop
      $slider.removeClass("is-hidden");
    }
  }

  initBlackFridayMobileSlider();

  // Run on load + resize
  $(window).on("resize", initBlackFridayMobileSlider);

  // Product Category Slider
  function initProductCategorySlider() {
    var $slider = $(".product-category-row");

    if (!$slider.length) return;

    // Get arrow visibility setting from data attribute
    // Convert string "true"/"false" to actual boolean
    var showArrows = $slider.data('show-arrows');
    if (typeof showArrows === 'string') {
      showArrows = showArrows === 'true';
    }

    // Destroy existing Flickity instance if it exists
    if ($slider.hasClass("flickity-enabled")) {
      $slider.flickity("destroy");
    }

    // Initialize Flickity
    $slider.flickity({
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: showArrows,
      wrapAround: true,
      autoPlay: 2800,
      pauseAutoPlayOnHover: true,
      adaptiveHeight: false,
      draggable: true,
      freeScroll: false,
      selectedAttraction: 0.01,
      friction: 0.25,
    });
  }

  initProductCategorySlider();

  // Product Featured Videos
  if ($(".video-container").length) {
    $videoContainer = $(".video-container");
    $videoContainer.find(".play-pause-button").on("click", function () {
      $videoItem = $(this).closest(".product-feature-video").find("video");
      if ($videoItem.prop("paused")) {
        $videoContainer.find("video").each(function () {
          if (!this.paused) {
            this.pause();
            $(this).closest(".product-feature-video").removeClass("is-playing");
          }
        });

        $videoItem.get(0).play();
        $(this).closest(".product-feature-video").addClass("is-playing");
      } else {
        $videoItem.get(0).pause();
        $(this).closest(".product-feature-video").removeClass("is-playing");
      }
    });
  }

  function updateMattressUI() {
    var selectedRadio = $(
      '.custom-mattress-variant input[type="radio"]:checked'
    );
    var mattressType = selectedRadio.val() || "Premium";

    // Hide both
    $(".premium-mattress, .classic-mattress").hide();

    if (mattressType === "Premium") {
      $(".premium-mattress").show();
    } else if (mattressType === "Classic") {
      $(".classic-mattress").show();
    }

    // Update product title
    /*var customProductTitle = $("#komfort-matratze .custom-product-title");
  if (customProductTitle.length) {
    let originalTitle = customProductTitle.text().replace(/^(Premium |Classic )/, "").trim();
    customProductTitle.text(mattressType + " " + originalTitle);
  }*/
    var customProductTitle = $("#komfort-matratze .custom-product-title");
    customProductTitle.each(function () {
      let $title = $(this);
      let originalTitle = $title
        .text()
        .replace(/^(Premium |Classic )/, "")
        .trim();
      $title.text(mattressType + " " + originalTitle);
    });
  }

  function bindMattressVariantEvents() {
    $(document).on(
      "change",
      '.custom-mattress-variant input[type="radio"]',
      function () {
        updateMattressUI();
      }
    );

    // Also update once on load
    updateMattressUI();
  }

  // Shopify sections may load dynamically, so wait for DOM + re-bind
  $(document).ready(function () {
    bindMattressVariantEvents();

    // Also listen to Shopify's variant change (if applicable)
    $(document).on("variant:change", function () {
      updateMattressUI();
    });
  });

  if ($("#komfort-matratze").length > 0) {
    var targetVariantIds = [53588776550668, 49168155771148];

    function toggleSection(variantId) {
      if (targetVariantIds.includes(parseInt(variantId))) {
        $(".progress-section").hide();
      } else {
        $(".progress-section").show();
      }
    }

    // Initial check on page load
    var initialSelected = $('variant-radios input[type="radio"]:checked');
    if (initialSelected.length > 0) {
      initialSelected.each(function () {
        var variantId = $(this).data("value");
        if (variantId) {
          toggleSection(variantId);
        }
      });
    }

    // Listen for variant selection changes
    $(document).on("change", 'variant-radios input[type="radio"]', function () {
      var selectedVariantId = $(this).data("value");
      toggleSection(selectedVariantId);
    });
  }

  //********************************************************************************** //
  // MEGA MENU
  $(".site-nav").on("click", ".menu-has-dropdown-wrap button", function (e) {
    e.stopPropagation(); // prevent click bubbling to document

    const $container = $(this).parents(".site-nav__link-container").first();
    const isActive = $container.hasClass("nav-hover");

    $(".site-nav__link-container").removeClass("nav-hover");

    if (!isActive) {
      $container.addClass("nav-hover");
    }
  });

  // Handle clicks outside the menu to remove nav-hover
  $(document).on("click", function (e) {
    //$(".site-nav__link-container").removeClass("nav-hover");
    if (
      !$(e.target).closest(".site-nav__link-container, .menu-has-dropdown-wrap")
        .length
    ) {
      $(".site-nav__link-container").removeClass("nav-hover");
    }
  });
  $(".site-nav .site-nav__link-container .menu-has-dropdown").on(
    "mouseenter",
    function () {
      const $container = $(this).closest(".site-nav__link-container");
      // Remove 'nav-hover' from all other containers
      $(".site-nav__link-container").not($container).removeClass("nav-hover");
      // Add 'nav-hover' to the current one
      $container.addClass("nav-hover");
    }
  );

  $(".site-nav .site-nav__link-container .main-menu-dropdown").on(
    "mouseleave",
    function () {
      $(this).parent(".site-nav__link-container").removeClass("nav-hover");
    }
  );

  //********************************************************************************** //
  //MOBILE MENU ACCORDION
  $(".menu-accordion li:has(.custom-submenu) .link").click(function () {
    $(this).parents("li").toggleClass(" active ");
    $(this).siblings().removeClass(" active ");
    $(".custom-submenu").stop().slideUp();
    $(".active .custom-submenu").stop().slideDown();
    return false;
  });

  //********************************************************************************** //
  //MAIN NAVIGATION SCROLL EFFECT
  var topPosition = 0;
  $(window).scroll(function () {
    var scrollMovement = $(window).scrollTop();
    if (topPosition < 200) {
      $("#header").addClass("top-header");
      $("#header").removeClass("show-header");
    } else {
      $("#header").removeClass("top-header");

      if (scrollMovement > topPosition) {
        $("#header").removeClass("show-header");
        $("#header").addClass("hide-header");
      } else {
        $("#header").removeClass("hide-header");
        $("#header").addClass("show-header");
      }
    }
    topPosition = scrollMovement;
  });

  // FAQS ACCORDION
  $(".faq-accordion").on("click", function () {
    $(this).toggleClass("active");

    var panel = $(this).next();

    if (panel.css("display") === "block") {
      panel.css("display", "none");
    } else {
      panel.css("display", "block");
    }
  });

  // FOOTER MENU ACCORDION
  $(".menu-accordion-btn").on("click", function () {
    $(this).toggleClass("active");

    var panel = $(this).next();

    if (panel.css("display") === "block") {
      panel.css("display", "none");
    } else {
      panel.css("display", "block");
    }
  });

  //********************************************************************************** //
  // PRODUCT DESCRIPTION ACCORDION
  $(".accordion-btn").on("click", function () {
    $(this).toggleClass("active");

    var panel = $(this).next();

    if (panel.css("display") === "block") {
      panel.css("display", "none");
    } else {
      panel.css("display", "block");
    }
  });

  // CUSTOM COUNTER
  if ($(".counter-wrap-inner #count").length) {
    let target = 98;
    let count = 0;
    let speed = 30; // speed of counting

    let interval = setInterval(function () {
      if (count < target) {
        count++;
        $(".counter-wrap-inner #count").text(count);
      } else {
        clearInterval(interval);
      }
    }, speed);
  }

  // CONTACT INFO STATUS BAR
  if ($(".contact-status-wrap").length) {
    // Get the start and end times from the input
    var startTime = $(".contact-start-time").val();
    var endTime = $(".contact-end-time").val();

    // Get current time in HH:MM format
    var now = new Date();
    var currentTime = now.toTimeString().slice(0, 5);

    // Check if the current time is between start and end times
    if (currentTime >= startTime && currentTime <= endTime) {
      $(".contact-status-wrap").removeClass("hide");
    } else {
      $(".contact-status-wrap").addClass("hide");
    }
  }

  var variant1Options = $(".swatch--1 input");
  var variant2Fieldset = $(".swatch--2"); // Adjust for your option2 fieldset index

  // ********************************************************************************** //
  // Add CSS for out-of-stock color swatch overlay
  if (!$("#out-of-stock-swatch-styles").length) {
    $("<style id='out-of-stock-swatch-styles'>")
      .text(
        `
        .swatch-element__color.out-of-stock-swatch::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to top right,
            transparent 0%,
            transparent calc(50% - 1px),
            rgba(0,0,0,0.6) 50%,
            transparent calc(50% + 1px),
            transparent 100%
          );
          pointer-events: none;
          border-radius: inherit;
        }
        .swatch-element__color.out-of-stock-swatch {
          position: relative;
          opacity: 0.4 !important;
        }
      `
      )
      .appendTo("head");
  }

  // ********************************************************************************** //
  // Helper function to determine the last (highest numbered) variant index
  function getLastVariantIndex() {
    var maxIndex = 0;
    $('[class*="swatch--"]').each(function () {
      var match = $(this)
        .attr("class")
        .match(/swatch--(\d+)/);
      if (match) {
        maxIndex = Math.max(maxIndex, parseInt(match[1]));
      }
    });
    return maxIndex;
  }

  // ********************************************************************************** //
  // DYNAMIC SHIPPING TEXT - Works with 0, 1, 2, or 3 variant options
  function updateVariantInfo() {
    // First, ensure we start with a clean state
    $("#sold-out-info").addClass("d-none");

    // Get product data
    var productDataElement = document.getElementById(
      "ProductJson-product-template"
    );
    if (!productDataElement) {
      return; // Exit if no product data found
    }

    var productData = JSON.parse(productDataElement.textContent);

    // Dynamically get all selected variant values
    var selectedOptions = {};
    var selectedVariantId = null;

    // Check how many variant swatches exist and get their values
    var hasVariants = $('[class*="swatch--"]').length > 0;

    if (hasVariants) {
      $('[class*="swatch--"]').each(function () {
        var swatchClass = $(this)
          .attr("class")
          .match(/swatch--(\d+)/);
        if (swatchClass) {
          var optionIndex = parseInt(swatchClass[1]);
          var selectedVal = $(this).find("input:checked").val();
          if (selectedVal) {
            selectedOptions["option" + optionIndex] = selectedVal;
          }

          // Also try to get the variant ID from the checked input
          var checkedInput = $(this).find("input:checked");
          if (checkedInput.length && checkedInput.data("value")) {
            selectedVariantId = checkedInput.data("value");
          }
        }
      });
    }

    var matchingVariant;

    // If product has no variant options (only default variant), use the first variant
    if (
      !hasVariants &&
      productData.variants &&
      productData.variants.length === 1
    ) {
      matchingVariant = productData.variants[0];
    } else {
      // Find the matching variant based on all selected options
      matchingVariant = productData.variants.find(function (v) {
        var matches = true;
        for (var i = 1; i <= 3; i++) {
          var optionKey = "option" + i;
          if (selectedOptions[optionKey]) {
            if (v[optionKey] !== selectedOptions[optionKey]) {
              matches = false;
              break;
            }
          }
        }
        return matches;
      });

      // If we still don't have a match, try using the variant ID directly
      if (!matchingVariant && selectedVariantId) {
        matchingVariant = productData.variants.find(function (v) {
          return v.id === selectedVariantId;
        });
      }
    }

    if (matchingVariant) {
      var variantShipping = "";
      var productShipping = "";
      var productAvailable = matchingVariant.available;

      // For products with variants, try to get shipping data from the input elements
      if (hasVariants) {
        // Find the input element for this variant to get shipping data
        // Try to find the input with this variant ID, prioritizing checked inputs
        var matchingInput = $(
          'input[data-value="' + matchingVariant.id + '"]:checked'
        ).first();

        // If not found (not currently checked), look for any input with this variant ID
        if (!matchingInput.length) {
          matchingInput = $(
            'input[data-value="' + matchingVariant.id + '"]'
          ).first();
        }

        // If still not found, try getting any checked input (fallback)
        if (!matchingInput.length) {
          matchingInput = $('[class*="swatch--"] input:checked').last();
        }

        if (matchingInput.length) {
          variantShipping = matchingInput.data("variant-shipping");
          productShipping = matchingInput.data("product-shipping");
        }
      }

      // For products with no variants, get shipping from metafields in product data
      if (!hasVariants) {
        // Try to get from variant metafields or product metafields
        if (productData.metafields && productData.metafields.custom) {
          productShipping = productData.metafields.custom.shipping || "";
        }
      }

      // Update Add to Cart button state
      var $addToCartBtn = $(".product-form__submit, .add-to-cart-btn");
      if (!productAvailable) {
        $addToCartBtn.prop("disabled", true);
        $addToCartBtn
          .find("span")
          .text(
            $addToCartBtn.find("span").data("sold-out-text")
          );

        // Only update shipping display for products WITH variants
        // Products without variants use Liquid-rendered shipping info
        if (hasVariants) {
          // Hide shipping info and show sold-out message
          $(".shipping-product-wrapper").addClass("d-none");
          $("#sold-out-info").removeClass("d-none");
          $("#shipping-info").addClass("d-none");
          $("#shipping-product-info").addClass("d-none");
        }
      } else {
        $addToCartBtn.prop("disabled", false);
        $addToCartBtn
          .find("span")
          .text(
            $addToCartBtn.find("span").data("add-to-cart-text")
          );

        // Only update shipping display for products WITH variants
        // Products without variants use Liquid-rendered shipping info
        if (hasVariants) {
          // Always hide sold-out message when available
          $("#sold-out-info").addClass("d-none");
          $(".shipping-product-wrapper").addClass("d-none");
          $("#shipping-product-info").addClass("d-none");

          // Show shipping info and populate text
          $("#shipping-info").removeClass("d-none");
          if (variantShipping && variantShipping.length) {
            $("#shipping-info .shipping-text").html(variantShipping);
          } else if (productShipping && productShipping.length) {
            $("#shipping-info .shipping-text").html(productShipping);
          } else {
            $("#shipping-info .shipping-text").html("");
          }
        }
      }
    }
  }

  function handleVariantSelection() {
    // Only run this function if product has variants
    if ($('[class*="swatch--"]').length === 0) {
      return;
    }

    // Immediately hide sold-out message when color changes
    // This ensures the message doesn't stick from the previous color
    $("#sold-out-info").addClass("d-none");
    $("#shipping-info").removeClass("d-none");

    var selectedVariant1 = $(".swatch--1 input:checked").val();
    // console.log("SWATCH 1: ", selectedVariant1);
    var availableOptions = window.variantMapping[selectedVariant1] || [];

    // Get product variants data from the script tag
    var productData = JSON.parse(
      document.getElementById("ProductJson-product-template").textContent
    );

    // Check if variant 2 is the last variant - only apply opacity if it is
    var lastVariantIndex = getLastVariantIndex();
    var isVariant2Last = lastVariantIndex === 2;

    // Loop through variant 2 options and hide/show based on mapping
    variant2Fieldset.find('input[type="radio"]').each(function () {
      var optionValue = $(this).val();
      var label = $(this).next("label");
      var isChecked = $(this).is(":checked");

      if (availableOptions.includes(optionValue)) {
        $(this).show();
        label.show();

        // Check if this specific combination is available
        var matchingVariant = productData.variants.find(function (v) {
          return v.option1 === selectedVariant1 && v.option2 === optionValue;
        });

        // Only apply opacity logic if this is the last variant
        // Style unavailable variants but keep them clickable

        if (isVariant2Last && matchingVariant && !matchingVariant.available) {
          $(this).prop("disabled", false); // Keep clickable

          // Check if this is a color swatch (visual element)
          if (label.hasClass("swatch-element__color")) {
            // For color swatches, ALWAYS add the diagonal line overlay if out of stock
            // (even if currently selected, to show it's unavailable)
            label.addClass("out-of-stock-swatch");
            label.css("cursor", "pointer");
          } else {
            // For text swatches, ALWAYS apply opacity and strikethrough if out of stock
            // (even if currently selected, to show it's unavailable)
            label.css("opacity", "0.4");
            label.css("text-decoration", "line-through");
            label.css("cursor", "pointer");
          }
        } else {
          $(this).prop("disabled", false);

          // Remove out-of-stock styling for both color and text swatches
          label.removeClass("out-of-stock-swatch");
          label.css("opacity", "1");
          label.css("text-decoration", "none");
          label.css("cursor", "pointer");
        }
      } else {
        $(this).hide();
        label.hide();
      }
    });

    // Automatically select the first visible option if the selected one is hidden
    var checkedOption = variant2Fieldset
      .find('input[type="radio"]:checked')
      .val();
    if (!availableOptions.includes(checkedOption)) {
      variant2Fieldset
        .find('input[type="radio"]')
        .filter(":visible")
        .first()
        .prop("checked", true)
        .trigger("change");
    } else {
      // Even if the same size option remains selected, we need to update the variant info
      // because the color changed and the availability of the combination may have changed
      updateVariantInfo();
    }
  }

  // ********************************************************************************** //
  // Initialize variant styling on page load
  function initializeVariantStyling() {
    // Small delay to ensure product data is fully loaded
    setTimeout(function () {
      // Call both handlers to ensure all variants are properly styled on load
      handleVariantSelection();

      // Additional delay for reverse handler
      setTimeout(function () {
        handleReverseVariantSelection();
      }, 100);
    }, 100);
  }

  // Listen for change on Variant 1
  variant1Options.on("change", handleVariantSelection);

  // Trigger on load
  initializeVariantStyling();

  // ********************************************************************************** //
  // REVERSE HANDLER: When Variant 2 changes, update Variant 1 styling
  function handleReverseVariantSelection() {
    // Only run this function if product has variants
    if ($('[class*="swatch--"]').length === 0) {
      return;
    }

    // Check if both variant fieldsets exist
    if ($(".swatch--2").length === 0 || $(".swatch--1").length === 0) {
      return; // Exit if we don't have both variants
    }

    var selectedVariant2 = $(".swatch--2 input:checked").val();

    // Get product variants data from the script tag
    var productData = JSON.parse(
      document.getElementById("ProductJson-product-template").textContent
    );

    // Check if variant 1 is the last variant - only apply opacity if it is
    var lastVariantIndex = getLastVariantIndex();
    var isVariant1Last = lastVariantIndex === 2;

    // Loop through variant 1 options and style based on availability with selected variant 2
    $(".swatch--1")
      .find('input[type="radio"]')
      .each(function () {
        var optionValue = $(this).val();
        var label = $(this).next("label");
        var isChecked = $(this).is(":checked");

        // Check if this specific combination is available
        var matchingVariant = productData.variants.find(function (v) {
          return v.option1 === optionValue && v.option2 === selectedVariant2;
        });

        // Only apply opacity logic if variant 1 is the last variant
        // Style unavailable variants but keep them clickable
        if (isVariant1Last && matchingVariant && !matchingVariant.available) {
          $(this).prop("disabled", false); // Keep clickable

          // Check if this is a color swatch (visual element)
          if (label.hasClass("swatch-element__color")) {
            // For color swatches, ALWAYS add the diagonal line overlay if out of stock
            // (even if currently selected, to show it's unavailable)
            label.addClass("out-of-stock-swatch");
            label.css("cursor", "pointer");
          } else {
            // For text swatches, ALWAYS apply opacity and strikethrough if out of stock
            // (even if currently selected, to show it's unavailable)
            label.css("opacity", "0.4");
            label.css("text-decoration", "line-through");
            label.css("cursor", "pointer");
          }
        } else {
          $(this).prop("disabled", false);

          // Remove out-of-stock styling for both color and text swatches
          label.removeClass("out-of-stock-swatch");
          label.css("opacity", "1");
          label.css("text-decoration", "none");
          label.css("cursor", "pointer");
        }
      });

    // Update variant info after styling
    updateVariantInfo();
  }

  // Listen for change on Variant 2
  $(".swatch--2 input").on("change", handleReverseVariantSelection);

  // VARIANT STATUS CODE
  // REMOVE STOCK CODE ON THE FIRST VARIANT
  var getOptionVal = $(".custom-option-label").val();

  if (getOptionVal == "Bezugart") {
    $(".swatch--1 .custom-variant .stock-circle-legend").css("display", "none");
  }

  var productTemplate =
    $("#product_template").offset().top + $("#product_template").outerHeight();

  $(window).on("scroll", function () {
    const isSmallDevice = $(window).width() <= 890;
    if ($(window).scrollTop() > productTemplate) {
      $(".sticky-cart").fadeIn(); // Show the cart
      $(".footer__block-wrapper").css("padding-bottom", "100px");

      if (isSmallDevice) {
        $(".chatway--trigger-container").css("bottom", "88px");
        $("#bik-chat-iframe").css("bottom", "95px");
      } else {
        $(".chatway--trigger-container").css("bottom", "10px");
        $("#bik-chat-iframe").css("bottom", "10px");
      }
    } else {
      $(".sticky-cart").fadeOut(); // Hide the cart
      $(".footer__block-wrapper").css("padding-bottom", "30px");
      $(".chatway--trigger-container").css("bottom", "10px");
      $("#bik-chat-iframe").css("bottom", "10px");
    }
  });

  $(window).on("scroll", function () {
    const isSmallDevice = $(window).width() <= 890;
    if ($(window).scrollTop() > productTemplate) {
      $(".sticky-cart").fadeIn(); // Show the cart
      $(".footer__block-wrapper").css("padding-bottom", "100px");

      if (isSmallDevice) {
        $(".woot-widget-bubble").css("bottom", "95px");
      } else {
        $(".woot-widget-bubble").css("bottom", "10px");
      }
    } else {
      $(".sticky-cart").fadeOut(); // Hide the cart
      $(".footer__block-wrapper").css("padding-bottom", "30px");
      
      $(".woot-widget-bubble").css("bottom", "10px");
    }
  });

  //********************************************************************************** //
  // GET SELECTED VARIANT FOR STICKY CART
  // FIRST VARIANT
  function formatToGermanMoney(price) {
    const adjustedPrice = price / 100;
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(adjustedPrice);
  }

  function getFirstSelectedVariant() {
    var selectVariant1 = $(".swatch--1 input:checked").val();
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice1 = $(".swatch--1 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice1 = $(
      ".swatch--1 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice1 = formatToGermanMoney(getVariantPrice1);
    var formattedComparePrice1 = formatToGermanMoney(getVariantComparePrice1);
    var getProductAvailable1 = $(
      ".swatch--1 input[data-available]:checked"
    ).data("available");
    var getVariantImage1 = $(".swatch--1 input[data-price]:checked").data(
      "image"
    );

    if (selectVariant1) {
      $(".sticky-cart-first-option-value").text(selectVariant1);
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice1);
      $(".sticky-cart-compare-price").text(formattedComparePrice1);

      if (getVariantImage1) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage1
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage1
        );
      }

      if (getProductAvailable1 == false) {
        $(".btn-sticky-cart").prop("disabled", true);
        $(".btn-sticky-cart").text("Ausverkauft");
      } else {
        $(".btn-sticky-cart").removeAttr("disabled", true);
        $(".btn-sticky-cart").text("Hinzufügen");
      }

      if (getVariantComparePrice1 > getVariantPrice1) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  }

  // Call the function to handle the first selected variant on page load
  getFirstSelectedVariant();

  // Add an event listener to detect changes to the input
  $(".swatch--1 input").on("change", function () {
    var selectVariant1 = $(".swatch--1 input:checked").val();
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice1 = $(".swatch--1 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice1 = $(
      ".swatch--1 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice1 = formatToGermanMoney(getVariantPrice1);
    var formattedComparePrice1 = formatToGermanMoney(getVariantComparePrice1);
    var getProductAvailable1 = $(
      ".swatch--1 input[data-available]:checked"
    ).data("available");
    var getVariantImage1 = $(".swatch--1 input[data-price]:checked").data(
      "image"
    );

    // VARIANT 2
    var getVariantImage2 = $(".swatch--2 input[data-price]:checked").data(
      "image"
    );
    var getVariantPrice2 = $(".swatch--2 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice2 = $(
      ".swatch--2 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice2 = formatToGermanMoney(getVariantPrice2);
    var formattedComparePrice2 = formatToGermanMoney(getVariantComparePrice2);

    if (getProductAvailable1 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Ausverkauft");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Hinzufügen");
    }

    if (selectVariant1) {
      $(".sticky-cart-first-option-value").text(selectVariant1);
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice1);
      $(".sticky-cart-compare-price").text(formattedComparePrice1);

      if (getVariantImage1) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage1
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage1
        );
      }

      if (getVariantComparePrice1 > getVariantPrice1) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  });

  // SECOND VARIANT
  function getSecondSelectedVariant() {
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice2 = $(".swatch--2 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice2 = $(
      ".swatch--2 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice2 = formatToGermanMoney(getVariantPrice2);
    var formattedComparePrice2 = formatToGermanMoney(getVariantComparePrice2);
    var getProductAvailable2 = $(
      ".swatch--2 input[data-available]:checked"
    ).data("available");
    var getVariantImage2 = $(".swatch--2 input[data-price]:checked").data(
      "image"
    );

    if (getProductAvailable2 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Ausverkauft");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Hinzufügen");
    }

    if (selectVariant2) {
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice2);
      $(".sticky-cart-compare-price").text(formattedComparePrice2);

      if (getVariantImage2) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage2
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage2
        );
      }

      if (getVariantComparePrice2 > getVariantPrice2) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  }

  // Call the function to handle the first selected variant on page load
  getSecondSelectedVariant();

  // Add an event listener to detect changes to the input
  $(".swatch--2 input").on("change", function () {
    var selectVariant2 = $(".swatch--2 input:checked").val();
    var getVariantPrice2 = $(".swatch--2 input[data-price]:checked").data(
      "price"
    );
    var getVariantComparePrice2 = $(
      ".swatch--2 input[data-compare-price]:checked"
    ).data("compare-price");
    var formattedVariantPrice2 = formatToGermanMoney(getVariantPrice2);
    var formattedComparePrice2 = formatToGermanMoney(getVariantComparePrice2);
    var getProductAvailable2 = $(
      ".swatch--2 input[data-available]:checked"
    ).data("available");
    var getVariantImage2 = $(".swatch--2 input[data-price]:checked").data(
      "image"
    );

    if (getProductAvailable2 == false) {
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Ausverkauft");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Hinzufügen");
    }

    if (selectVariant2) {
      $(".sticky-cart-second-option-value").text(selectVariant2);
      $(".sticky-cart-price").text(formattedVariantPrice2);
      $(".sticky-cart-compare-price").text(formattedComparePrice2);

      if (getVariantImage2) {
        $(".sticky-cart-image img").attr(
          "src",
          "/cdn/shop/" + getVariantImage2
        );
        $(".sticky-cart-image img").attr(
          "data-src",
          "/cdn/shop/" + getVariantImage2
        );
      }

      if (getVariantComparePrice2 > getVariantPrice2) {
        $(".sticky-cart-product-price").addClass("sticky-cart-sale-price");
      } else {
        $(".sticky-cart-product-price").removeClass("sticky-cart-sale-price");
      }
    }
  });

  var stickyAvailable = $(".sticky-available").val();

  if (stickyAvailable.length != 0) {
    if (stickyAvailable == "false") {
      console.log("Disable button");
      $(".btn-sticky-cart").prop("disabled", true);
      $(".btn-sticky-cart").text("Ausverkauft");
    } else {
      $(".btn-sticky-cart").removeAttr("disabled", true);
      $(".btn-sticky-cart").text("Hinzufügen");
    }
  }

  //********************************************************************************** //
  // KLARNA PAYMENT
  function getKlarnaPayment() {
    $(".custom-variant input").on("change", function () {
      const price = $(".custom-variant input:checked").data("price");
      if (price !== undefined) {
        const pricePerMonth = price / 12;
        $(".klarna-price").text(formatToGermanMoney(pricePerMonth));
      }
    });
  }

  // Initial calculation on page load
  const initialPrice = $(".custom-variant input:checked").data("price");
  if (initialPrice !== undefined) {
    const initialPricePerMonth = initialPrice / 12;
    $(".klarna-price").text(formatToGermanMoney(initialPricePerMonth));
  } else {
    const productBasePrice = $(".price__sale .money").first().text().trim();
    rawText = productBasePrice.replace(/[^\d,]/g, "").replace(",", "");
    const initialPricePerMonth = rawText / 12;
    $(".klarna-price").text(formatToGermanMoney(initialPricePerMonth));
  }

  getKlarnaPayment();

  // Check if product has variants
  var hasVariants = $('[class*="swatch--"]').length > 0;

  if (hasVariants) {
    // For products WITH variants: Hide Liquid-controlled shipping, use JavaScript
    $(".shipping-product-wrapper").addClass("d-none");
    $("#shipping-product-info").addClass("d-none");
  } else {
    // For products WITHOUT variants: Hide JavaScript-controlled shipping, use Liquid
    $("#shipping-info").addClass("d-none");
    $("#sold-out-info").addClass("d-none");

    // Explicitly show Liquid-controlled sections
    $(".shipping-product-wrapper").removeClass("d-none");
    $("#shipping-product-info").removeClass("d-none");
  }

  updateVariantInfo();

  // Listen for changes on ANY variant swatch (works with 1, 2, or 3 variants)
  $(document).on("change", ".custom-variant input", function () {
    updateVariantInfo();
  });

  // Also listen for changes on any swatch fieldset
  $(document).on("change", '[class*="swatch--"] input', function () {
    updateVariantInfo();
  });
});

// Fix for product slider stopping on video slides (mobile)
$(document).ready(function() {
  if ($(window).width() <= 768) {
    // Function to disable video interaction
    function disableVideoInteraction() {
      $('.product__photo[data-product-media-type-video] video, .product__photo[data-product-media-type-video] iframe').each(function() {
        // Remove controls attribute to prevent touch targets
        this.removeAttribute('controls');
        // Force pointer-events and touch-action
        this.style.pointerEvents = 'none';
        this.style.touchAction = 'pan-y';
        this.style.webkitTouchAction = 'pan-y';
      });
    }

    // Apply on initial load
    disableVideoInteraction();

    // Re-apply after a delay to catch lazy-loaded videos
    setTimeout(disableVideoInteraction, 500);
    setTimeout(disableVideoInteraction, 1000);

    // Re-apply after slide changes (in case Shopify re-enables controls)
    window.addEventListener('loft:Product:Slide__Changed', function(event) {
      setTimeout(disableVideoInteraction, 100);
    });

    // Re-apply when video becomes visible
    $(document).on('mediaVisible', '.product__photo[data-product-media-type-video]', function() {
      disableVideoInteraction();
    });
  }
});

//HERO COUNTDOWN TIMER
// Set the date we're counting down to
if ($("#get-hero-countdown-date").length) {
  var getCountDownDate = $("#get-hero-countdown-date").val();
  var cleanedDateString = getCountDownDate.replace(/\s+/g, "");
  var countDownDate = new Date(cleanedDateString).getTime();

  // Update the countdown every 1 second
  var countdownfunction = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the countdown date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes, and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Loop through all countdown elements (if you have multiple slides)
    document.querySelectorAll("#hero-countdown").forEach(function (countdown) {
      countdown.querySelector("#days").innerHTML = days;
      countdown.querySelector("#hours").innerHTML = hours;
      countdown.querySelector("#minutes").innerHTML = minutes;
      countdown.querySelector("#seconds").innerHTML = seconds;
    });

    // If the countdown is over, display "EXPIRED"
    if (distance < 0) {
      clearInterval(countdownfunction);
      document.querySelectorAll("#hero-countdown").forEach(function (element) {
        element.style.display = "none";
      });
    }
  }, 1000);
}

//********************************************************************************** //
// REMOVE RATING TEXT ON MOBILE
/* var removeTextRating = setInterval(function () {
  document
    .querySelectorAll(".mobile-menu-rating .jdgm-prev-badge__text")
    .forEach(function (element) {
      console.log("REMOVE RATING");
      Replace the text and assign it back to textContent
      element.textContent = element.textContent
        .replace(" Bewertungen", "")
        .replace(" reviews", "")
        .replace(" review", "")
        .replace(" arvostelua", "")
        .replace(" arvostelua", "")
        .replace(" arvostelu", "")
        .replace(" avis", "")
        .replace(" recensioni", "")
        .replace(" recensione", "");
    });
}, 3000); */
const removeTextRating = setInterval(() => {
  document.querySelectorAll(".mobile-menu-rating .jdgm-prev-badge__text").forEach(el => {
    if (el.textContent.includes('+')) {
      el.textContent = el.textContent.replace(/\+\s*.*/, '').trim();
    } else if (el.textContent.trim().startsWith('(0)')) {
      el.textContent = '(0)';
    }
  });
  // Stop once we processed at least one badge
  if (document.querySelector(".mobile-menu-rating .jdgm-prev-badge__text")) {
    clearInterval(removeTextRating);
  }
}, 3000);
var changeRatingLabel = setInterval(function () {
  document
    .querySelectorAll(".featured-collection__product .jdgm-prev-badge__text")
    .forEach(function (element) {
      // console.log("REMOVE RATING");
      // Replace the text and assign it back to textContent
      element.textContent = element.textContent.replace(
        " reviews",
        " Bewertungen"
      );
      element.textContent = element.textContent.replace(
        " review",
        " Bewertungen"
      );
    });
}, 1000);

document.addEventListener("DOMContentLoaded", () => {
  //********************************************************************************** //
  // CUSTOM TABS
  // Select all tab buttons
  const tabButtons = document.querySelectorAll(".kk-tab-buttons .kk-tab-btn");

  // Select all tab content sections
  const tabContents = document.querySelectorAll(".kk-tab-content .kk-tab-pane");

  tabButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      // Remove 'active' class from all buttons and content sections
      tabButtons.forEach((tab) => tab.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add 'active' class to the clicked button
      button.classList.add("active");

      // Add 'active' class to the corresponding content section
      tabContents[index].classList.add("active");
    });
  });

  //********************************************************************************** //
  // OPEN CHATWAY APP
  function checkTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    var chat_laura = document.getElementById("chat-laura");
    if (chat_laura.length) {
      // Show button if time is 4:30 PM or later
      if (hours > 16 || (hours === 16 && minutes >= 30)) {
        document.getElementById("chat-laura").href =
          "javascript:window.bik_widget.open();";
      } else {
        document.getElementById("chat-laura").href =
          "javascript:$chatway.openChatwayWidget();";
      }
    }
  }
  checkTime(); // Run function on page load
});

function toggleImageIconWrap(lang) {
  const el = document.querySelector(".image-icon-wrap");
  if (!el) return;

  if (lang === "de") {
    el.style.display = "";
  } else {
    el.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (typeof Weglot !== "undefined") {
    toggleImageIconWrap(Weglot.getCurrentLang());

    console.log("LANGUAGE: ", Weglot.getCurrentLang());

    Weglot.on("languageChanged", function ({ newLang }) {
      toggleImageIconWrap(newLang);
    });
  }

  const getProductBadge =
    document.getElementById("product-badge").dataset.badge;
  const customImageBadge = document.querySelector(
    "#pwzrswiper-wrapper .pwzrswiper-slide:first-child"
  );
  const productBadgeWrapper = document.createElement("div");
  productBadgeWrapper.className = "image-badge-wrap lazyload lazysection";
  productBadgeWrapper.innerHTML = `<div class="image-badge">${getProductBadge}</div>`;
  customImageBadge.appendChild(productBadgeWrapper);
});

document.addEventListener("submit", (e) => {
  const form = e.target.closest("form");
  if (form && form.classList.contains("js-product-form")) {
    // Optional: add loading indicator here
    console.log("Submitting via ajax...");
  }
});


document.addEventListener('click', function (event) {
  const body = document.body;
  const cartDrawer = document.querySelector('.cart-drawer-box');
  const upsellModal = document.querySelector('.MyCartUpsells_Modal');

  if (!cartDrawer) return;

  // Skip if clicked the cart toggle button
  const clickedToggle = event.target.closest('[onclick*="js-ajax-cart-open"]');
  if (clickedToggle) return;

  // Skip if clicked inside cart drawer or upsell modal
  if (
    cartDrawer.contains(event.target) ||
    (upsellModal && upsellModal.contains(event.target))
  ) {
    return;
  }

  // Close the drawer if open
  if (body.classList.contains('js-ajax-cart-open')) {
    body.classList.remove('js-ajax-cart-open');
  }
});

document.addEventListener("click", function (e) {
  const badge = e.target.closest(".review-info");
  if (badge) {
    const reviewsSection = document.querySelector("#judgeme_product_reviews");
    if (reviewsSection) {
      reviewsSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
});
